import { AxiosResponse } from 'axios';

import httpRequest from '../httpRequest';

const propertyAPI = {
  getCanoneConcordatoUrl: async (propertyId: number) => {
    const { data } = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/properties/${propertyId}/url-calcolo-canone-concordato`,
      method: 'GET',
    })) as AxiosResponse;

    return data;
  },
};

export default propertyAPI;
